export default __webpack_public_path__ + "static/media/lombardKlein.b61e4853.jpg";